<template>
  <div class="bi-post-action">
    <div v-for="data in actionData" :key="data.id" class="mb-2">
      <div>
        <div class="label mt-2">{{ data.displayName || data.fieldName }}</div>
        <p class="" v-if="data.description">{{ data.description }}</p>
      </div>
      <div v-if="data.type === actionType.Input">
        <ValidationProvider :name="data.fieldName" v-slot="{ errors }" :rules="getInputRules(data)">
          <input type="text" class="form-control" v-model="data.value"  />
          <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max length is {{ data.rules.length }}</div>
        </ValidationProvider>
      </div>
      <div v-if="data.type === actionType.MinMax">
        <ValidationProvider v-slot="{ errors }" :name="data.fieldName" :rules="getMinMaxRules(data)">
          <input :name="data.fieldName" type="number" class="form-control" v-model="data.value" />

          <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max value is {{ data.rules.max }}</div>
        </ValidationProvider>
      </div>
      <div v-if="data.type === actionType.FromToDate">
        <ValidationProvider :name="data.fieldName" :rules="getRequiredRule(data)">
          <input type="text" v-show="false" v-model="data.value" />
        </ValidationProvider>

        <ActionDate :name="data.fieldName" :actionData="data"></ActionDate>
        <div v-if="!data.value && data.rules.isRequired" class="alert alert-danger" role="alert">{{ data.fieldName }} is required</div>
      </div>
      <div v-if="data.type === actionType.TextArea">
        <ValidationProvider :name="data.fieldName" v-slot="{ errors }" :rules="getTextAreaRules(data)">
          <textarea-autosize class="area form-control" v-model="data.value" :min-height="30"></textarea-autosize>

          <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max length is {{ data.rules.length }}</div>
        </ValidationProvider>
      </div>

      <div v-if="data.type === actionType.Checkbox || data.type === actionType.IncludeImages">
        <ValidationProvider :name="data.fieldName">
          <b-form-checkbox class="mb-1" v-model="data.value" :value="true" :unchecked-value="false">
            {{data.displayName || data.fieldName}}
          </b-form-checkbox>
        </ValidationProvider>
      </div>

      <div v-if="data.type === actionType.Multiselect">
        <ValidationProvider :name="data.fieldName">
          <action-multi-select :action-data="data" v-model="data.value"></action-multi-select>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import {
    IActionDataDto,
    ActionDataTypeDto,
    IBoardItemActionDto,
    ActionDataDto
  } from "@/apiclient/apiclient_generated";
  import ActionDate from '@/components/BoardItemActions/components/ActionDate.vue';
  import ActionMultiSelect from "@/components/BoardItemActions/components/ActionMultiSelect.vue";

  @Component({
    components: {
      ActionMultiSelect,
      ActionDate,
    },
  })
  export default class BoardItemPostAction extends Vue {
    @Prop()
    action: IBoardItemActionDto;
    actionType = ActionDataTypeDto;

    get actionData(): ActionDataDto[] {
      return this.lodash.sortBy(this.action.data, 'sortOrder');
    }

    getRequiredRule(actionData: IActionDataDto) {
      return { required: actionData.rules?.isRequired ?? false };
    }

    getInputRules(actionData: IActionDataDto) {
      const inputRules = this.getRequiredRule(actionData);

      if (inputRules.required) {
        inputRules['max'] = actionData.rules.length;
      }

      return inputRules;
    }

    getMinMaxRules(actionData: IActionDataDto) {
      const minMaxRules = this.getRequiredRule(actionData);

      if (minMaxRules.required) {
        minMaxRules['min_value'] = actionData.rules.min;
        minMaxRules['max_value'] = actionData.rules.max;
      }

      return minMaxRules;
    }

    getTextAreaRules(actionData: IActionDataDto) {
      const textAreaRules = this.getRequiredRule(actionData);

      if (textAreaRules.required) {
        textAreaRules['max'] = actionData.rules.length;
      }

      return textAreaRules;
    }
  }
</script>
